import React, { Component, createRef } from "react";
import { ReactComponent as CloseMark } from "assets/icons/close-mark.svg";
import { SearchIcon } from "component/icons";
import "component/menu/SearchBar/styles.scss";

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.inputRef = createRef();
    this.state = {
      focus: false,
    };
  }

  componentDidMount() {
    if (this.props.search) {
      this.inputRef.current.value = this.props.search;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.search !== this.props.search) {
      this.inputRef.current.value =
        this.props.search === undefined ? "" : this.props.search;
    }
  }

  render() {
    return (
      <div
        className={`search-bar-component ${this.props.hide ? "d-none" : ""}`}
      >
        <div
          className={`input-group input-group-sm mb-3  ${
            this.state.focus || this.props.search ? "focus" : ""
          }`}
        >
          <div className="input-group-prepend">
            <span className="input-group-text">
              <SearchIcon className="search-icon" />
            </span>
          </div>
          <input
            ref={this.inputRef}
            type="text"
            className="form-control"
            onFocus={() => {
              this.setState({
                focus: true,
              });
            }}
            onBlur={() => {
              this.setState({
                focus: false,
              });
            }}
            onInput={(e) => {
              if (
                this.props.onInput &&
                e.currentTarget.value !== this.props.search
              )
                this.props.onInput(e.currentTarget.value);
            }}
            placeholder={this.props.placeholder ? this.props.placeholder : null}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              {this.inputRef.current &&
                this.inputRef.current.value !== "" &&
                this.inputRef.current.value !== null && (
                  <CloseMark
                    className="search-icon"
                    onClick={() => {
                      this.inputRef.current.value = "";
                      const event = new Event("input", { bubbles: true });
                      this.inputRef.current.dispatchEvent(event);
                    }}
                  />
                )}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchBar;
